import * as React from "react";
function SvgHspAssign(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#5a5a5a"
        d="M18.8 1.3c.8 0 1.3.5 1.3 1.3v16.3c0 .8-.5 1.3-1.3 1.3H1.3C.5 20 0 19.5 0 18.8V2.5c0-.8.5-1.3 1.3-1.3H5v2.5H2.5v13.8h15V3.8H15V1.3h3.8zM6.3 0h7.5v5H6.3V0zm7.5 10v2.5h-2.5V15H8.8v-2.5H6.3V10h2.5V7.5h2.5V10h2.5z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgHspAssign);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
